export const environment = {
    production: false,
    apiBaseUrl: 'https://apidomiciliario.labsura.com',
    //apiBaseUrl: 'http://192.168.40.114:8091',
    programadorBaseUrl: 'https://programador-domiciliario.labsura.com',
    portBaseUrl: '',
    seusBaseUrl: 'https://domiciliario.labsura.com/',
    geoSuraBaseUrl: 'https://geolab.sura.com',
    hada: {
        idComponent: 'web-component',
        env: 'labo',
        appsource: 'plataformaDomiciliaria',
        url: 'https://hada.labsura.com/static/js/wc-hada.js',
        initialroute: 'ODONTOLOGYHOME'
    },
    backend: {
        fire: {
            connection: {
                projectId: 'atenciondomiciliaria-lab',
                appId: '1:455598335422:web:c1a592166d5187404485ef',
                storageBucket: 'atenciondomiciliaria-lab.firebasestorage.app',
                apiKey: 'AIzaSyBuDyjggflonG7MzjjE-m2U91BoSJcXeZ4',
                authDomain: 'atenciondomiciliaria-lab.firebaseapp.com',
                messagingSenderId: '455598335422',
                measurementId: ''
            },
            emulate: false
        }
    }
};

